export default "__VITE_ASSET__BzfpfO4y__"